export interface CardNavigationPayload {
  service: string;
  year: string;
  entity: string;
}
